module.exports = __webpack_public_path__ + "static/assets/1c8a54f25d101bdc607cec7228247a9a.svg";